import type { ComponentType } from "react";
import { MeetingDayPreview } from "../calendar/MeetingDayPreview";
import type { ActionDescription } from "./actionModel";

/**
 * Content of its own for an action of a given kind (the server's `preview.kind`), between what it is and its values:
 * a meeting shows where it lands in everyone's day. A new kind is one entry here.
 */
const PREVIEWS: Record<string, ComponentType<{ action: ActionDescription }>> = {
  meeting: MeetingPreview,
};

export function ActionPreview({ action }: Readonly<{ action: ActionDescription }>) {
  const Preview = action.kind ? PREVIEWS[action.kind] : undefined;
  return Preview ? <Preview action={action} /> : null;
}

function MeetingPreview({ action }: Readonly<{ action: ActionDescription }>) {
  if (!action.day || !action.when) return null;
  return (
    <MeetingDayPreview
      day={action.day}
      start={action.when.start}
      end={action.when.end}
      organizer={action.day.people[0]?.email ?? null}
    />
  );
}
